export const sampleCars = [
  {
    id: '1',
    year: 2022,
    make: 'BMW',
    model: '330i',
    trim: 'M Sport Package',
    price: 45900,
    mileage: 18500,
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=500&h=300&fit=crop'
  },
  {
    id: '2',
    year: 2021,
    make: 'Audi',
    model: 'A4',
    trim: 'Premium Plus',
    price: 38750,
    mileage: 22100,
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    image: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500&h=300&fit=crop'
  },
  {
    id: '3',
    year: 2023,
    make: 'Mercedes-Benz',
    model: 'C-Class',
    trim: 'C 300 4MATIC',
    price: 52300,
    mileage: 8900,
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=500&h=300&fit=crop'
  },
  {
    id: '4',
    year: 2020,
    make: 'Lexus',
    model: 'ES 350',
    trim: 'Luxury',
    price: 34200,
    mileage: 35600,
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    image: 'https://images.unsplash.com/photo-1563720223185-11003d516935?w=500&h=300&fit=crop'
  },
  {
    id: '5',
    year: 2022,
    make: 'Tesla',
    model: 'Model 3',
    trim: 'Long Range',
    price: 48900,
    mileage: 12400,
    transmission: 'Single Speed',
    fuelType: 'Electric',
    image: 'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=500&h=300&fit=crop'
  },
  {
    id: '6',
    year: 2021,
    make: 'Porsche',
    model: 'Macan',
    trim: 'S',
    price: 67800,
    mileage: 16200,
    transmission: 'Automatic',
    fuelType: 'Gasoline',
    image: 'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=500&h=300&fit=crop'
  }
];